export default __webpack_public_path__ + "static/02-a22c0c57de350c3cec6d85fb38fa298e.jpg";